//imports needed for this function
import { ApiPromise, WsProvider } from '@polkadot/api';
const axios = require('axios');

export async function getBlockchainLag() {

  const wsProvider = new WsProvider(process.env.REACT_APP_WSPROVIDER_URL);
  const api = await ApiPromise.create({ provider: wsProvider });


  // Get last block from jetski
  var lastBlockFromJetski = await axios.get(process.env.REACT_APP_API_URL + "api/v1/jetski/info/" + process.env.REACT_APP_CHAIN_NAME)
  .then(function (response) {
    return response.data.data.latestBlock;
  })
  .catch(function (error) {
    console.error("Error while fetching current jetski block")
    return undefined;
  });

  // Get last block from API
  var lastHeader = await api.rpc.chain.getHeader();
  var lastBlockFromApi = lastHeader.number;

  // Calculate lag
  var lag = lastBlockFromApi - lastBlockFromJetski;

  console.log("Last block numbers : Jetski = " + lastBlockFromJetski + " / Chain = " + lastBlockFromApi + " / Lag = " + lag);

  return lag;
};